import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Admin_Parivartan_Create_SubCategory,
  Admin_Parivartan_Get_Category_Names,
} from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const priorities = [
  { label: "High", color: "#00B050" },
  { label: "Medium", color: "#FFFF00" },
  { label: "Low", color: "#FF0000" },
];

const AddNewSubcategoryModal = ({ isOpen, onClose, onRefresh}) => {
  const [categoryNames, setCategoryNames] = useState([]);

  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(
        `${Admin_Parivartan_Get_Category_Names}`
      );
      setCategoryNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [isOpen]);

  const [form, setForm] = useState({
    categoryId: "",
    SubCategoryName: "",
    priority: "",
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      subCategoryName: form.SubCategoryName,
      priority: form.priority,
      categoryId: form.categoryId,
    };

    try {
      const res = await axios.post(
        Admin_Parivartan_Create_SubCategory,
        payload
      );
      console.log("Response:", res);
      if (res.data.success) {
        toast.success("SubCategory Created Successfully.");
        onClose();
        onRefresh();
        handleReset();
      } else {
        toast.error(res.data.message || "Failed to create subcategory");
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const handleReset = () => {
    setForm({ categoryId: "", priority: "", subCategoryName: "" });
  };

  return (
    <>
      <div>
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Add New SubCategory
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>
              <Autocomplete
                fullWidth
                options={categoryNames}
                getOptionLabel={(option) => option?.CategoryName || ""}
                value={
                  categoryNames.find(
                    (cat) => cat.CategoryId === form.categoryId
                  ) || null
                }
                onChange={(e, newValue) =>
                  handleChange(
                    "categoryId",
                    newValue ? newValue.CategoryId : ""
                  )
                }
                size="small"
                renderInput={(params) => (
                  <TextField {...params} label="Category" variant="outlined" />
                )}
              />

              <Autocomplete
                fullWidth
                options={priorities}
                getOptionLabel={(option) => option.label}
                value={
                  priorities.find((p) => p.label === form.priority) || null
                }
                onChange={(e, newValue) =>
                  handleChange("priority", newValue ? newValue.label : "")
                }
                renderInput={(params) => (
                  <TextField {...params} label="Priority" variant="outlined" />
                )}
                size="small"
                renderOption={(props, option) => (
                  <li {...props}>
                    <span
                      style={{
                        display: "inline-block",
                        width: 12,
                        height: 12,
                        backgroundColor: option.color,
                        borderRadius: "50%",
                        marginRight: 8,
                      }}
                    />
                    {option.label}
                  </li>
                )}
              />

              <FormControl fullWidth>
                <TextField
                  label="SubCategory"
                  value={form.SubCategoryName}
                  onChange={(e) =>
                    handleChange("SubCategoryName", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                />
              </FormControl>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default AddNewSubcategoryModal;
